<template>
  <div v-if="email">
    <a class="emailcolumn" @click.stop :href="`mailto:${email}`">{{ email }}</a>
  </div>
</template>

<script>
export default {
  name:'EmailColumn',
  props: {
    email: {
      type: String
    }
  }

}
</script>

<style scope>

</style>
